import CollectivityLabel from 'src/models/collectivityLabel.js';

export function setLabel({ commit, rootGetters }) {
  const config = rootGetters['config/config'];

  const existingCollectivities = config.COLLECTIVITY_INFORMATION;
  const existingCollectivity = existingCollectivities.find((x) => window.location.origin.includes(x.urlPart));

  if (existingCollectivity?.redirectUrl) {
    window.location.href = existingCollectivity.redirectUrl;
    commit('setLabel', new CollectivityLabel('aev'));
    return;
  }

  if (existingCollectivity) commit('setLabel', new CollectivityLabel(existingCollectivity.label));
  else commit('setLabel', new CollectivityLabel('aev'));
}
